import api from '../../utils/api'

import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Navigate, useNavigate } from 'react-router-dom'




/* Hooks */
import useFlashMessage from '../../hooks/useFlashMessage'
import FormClient from './Form/FormClient'

function EditClient({id , btCancelAction, handleOnSuccess, sellerEnabled}){
    const [client, setClient] = useState({})
    const [token] = useState(localStorage.getItem('token') || '')
    /* const {id} = useParams() */
    const [load, setLoad] = useState(false)

    const {setFlashMessage} = useFlashMessage()
    const navigate = useNavigate()

    useEffect(() => {

        api.get(`/client/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },

        }).then((response) => {
            setClient(response.data.client)
            setLoad(true)
        })
    }, [token, id])

    async function updateClient(client) {
        let msgType = 'success'
        
        
        const data = await api.patch(`client/${client._id}`, client, {
            headers: {
            Authorization: `Bearer ${JSON.parse(token)}`,
        },
        }).then((response) => {
            
            return response.data
        }).catch((err) => {
            
            msgType= 'error'
            return err.response.data
        })
        setFlashMessage(data.message, msgType)
        if (msgType !== 'error'){
            handleOnSuccess()
            /* navigate('/client') */
            }

    }


    return (
        <section>
            {client.name && (
                <FormClient title="Editar Cliente" sellerEnabled={sellerEnabled} handleSubmit={updateClient} btnText="Salvar" btCancelAction={btCancelAction} clientData={client} />
            )}
        </section>
    )
}

export default EditClient